import { Variants } from 'framer-motion';

// Animation configurations
export const C_ANIMATION_CONFIG = {
  duration: 0.3,
  ease: 'easeInOut'
} as const;

export const C_SLIDE_ANIMATION_CONFIG = {
  duration: 0.2,
  ease: 'easeOut'
} as const;

// Slide variants for stack navigation
export const C_SLIDE_VARIANTS: Variants = {
  enter: (_dir: number) => ({ x: -0, opacity: 0 }),
  center: { x: 0, opacity: 1 },
  exit: (_dir: number) => ({ x: 0, opacity: 0 })
};

// Sheet height calculations
export const C_SHEET_HEIGHT_CONFIG = {
  maxHeightPercent: 0.7,
  paddingHeight: 15, // padding + handle height
  measurementDelay: 400
} as const;

// Device detection breakpoints
export const C_DEVICE_BREAKPOINTS = {
  mobile: 768,
  tablet: 1024,
  desktop: 1025
} as const;

// Smart modal default behaviors
export const C_SMART_MODAL_BEHAVIORS = {
  dialog: {
    mobile: { type: 'dialog' as const, position: 'center' as const },
    tablet: { type: 'dialog' as const, position: 'center' as const },
    desktop: { type: 'dialog' as const, position: 'center' as const }
  },
  sheet: {
    mobile: { type: 'sheet' as const, position: 'bottom' as const },
    tablet: { type: 'sheet' as const, position: 'bottom' as const },
    desktop: { type: 'sheet' as const, position: 'right' as const }
  },
  sheetCenter: {
    mobile: { type: 'sheet' as const, position: 'bottom' as const },
    tablet: { type: 'dialog' as const, position: 'center' as const },
    desktop: { type: 'dialog' as const, position: 'center' as const }
  }
} as const;
